<!-- The Preview Modal Footer Component -->
<!-- Description: Creating a footer for the base modal component -->
<template>
    <!-- Declaring a row (tag from Bootstrap for Vue) -->
    <b-row style="margin-top: 20px; margin-left: 0;">
        <b-col cols="5">
            <div class="margin-left">
                <!-- Creating an add button -->
                <base-button button_type="btn-success" style="display: inline-block;" icon_type="icon-simple-add"
                             @click="add"></base-button>
                {{ selected.quantity }}
                <!-- Creating a remove button -->
                <base-button button_type="btn-success" style="display: inline-block;" icon_type="icon-simple-delete"
                             @click="subtract"></base-button>
            </div>
        </b-col>
        <b-col cols="7">
            <div style="margin-right: 15px; margin-left: 15px; float: right;">
                <h5 class="title" style="font-size: 15pt">
                    Цена: {{ price }}
                    <!-- Creating a submit button -->
                    <base-button button_type="btn-success" icon_type="icon-triangle-right-17" @click="submit"
                                 v-b-tooltip.hover title="Добавяне в количката"></base-button>
                </h5>
            </div>
        </b-col>
    </b-row>
</template>

<!-- TypeScript code -->
<script>
    // Importing components
    import BaseButton from '@/ui/BaseButton.vue';
    // Importing functions
    import {validateItem} from '../../../ts/cart/validate-item';

    export default {
        name: 'ThePreviewModalFooter',
        components: {
            BaseButton,
        },
        props: {
            selected: Object,
            product: Object,
            ingredients: Array,
        },
        computed: {
            price() {
                let temp = 0;
                for (const item of Object.entries(this.selected.addons)) {
                    for (const property of item[1]) {
                        temp = temp + Number(property.price_with_vat);
                    }
                }
                return (this.selected.quantity * (Number(this.selected.variation.price) + temp)).toFixed(2);
            },
        },
        methods: {
            add() {
                if (this.selected.quantity < 5) { this.selected.quantity++; }
            },
            subtract() {
                if (this.selected.quantity !== 1) { this.selected.quantity--; }
            },
            hide() {
                this.$modal.hide('modal_' + this.product.id);
            },
            submit() {
                let reverseIngredients = Object.assign([], this.selected.ingredients);
                reverseIngredients = this.ingredients.filter((item) => !reverseIngredients.includes(item));
                const tempAddons = {};
                for (const item of Object.entries(this.selected.addons)) {
                    tempAddons[item[0]] = [];
                    for (const property of item[1]) {
                        tempAddons[item[0]].push(property.name);
                    }
                }
                this.errors = [];
                validateItem(this.errors, this.product.attributes.addons, tempAddons, this.selected.variation.id);
                if (this.errors.length === 0) {
                    this.$emit('newItem', {
                        product: this.selected.variation.id,
                        quantity: this.selected.quantity,
                        ingredients: JSON.stringify(reverseIngredients),
                        addons: JSON.stringify(tempAddons),
                    });
                    this.hide();
                }
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    input[type][disabled] { background-color: #f9f9f9; color: #ddd; cursor: default; }
    input[type][disabled] + label { color: #999; cursor: default; }
    .margin-left { margin-left: 15px; }
    label {
        font: 300 16px/1.7 'Open Sans', sans-serif;
        color: #666;
        cursor: pointer;
    }
</style>